import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PrimaryButton from './button/PrimaryButton';
import pikkoWelcomeHome2 from '../styles/img/account/pikkoWelcomeHome2.svg';
import { deployScan } from '../utils/guestModeTrigger';
import useAxios from '../axios/useAxios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { UPDATE_USER } from '../constants/routes';
import clsx from 'clsx';
import { posthogPhoneNumberEvent } from '../posthog/phoneNumberEvent';
import {
  POSTHOG_CAPTURE_PHONE_SIGN_UP_FUNNEL_COMPLETED
} from '../posthog/constants';

const UserInfo = ({ isNewUser }) => {
  const [open, setOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const user = useSelector((state) => state.user);
  const { store } = useSelector((state) => state.store);
  const location = useLocation();
  const dispatch = useDispatch();
  const axiosInstance = useAxios();
  const navigate = useNavigate();

  const entryQr = location.state?.entryQr || localStorage.getItem('entryQr') || '';
  const cartItems = useSelector((state) => state.cart.cartItems);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const popupUser = localStorage.getItem('popupUser');
    if (user?._id && !popupUser) {
      setOpen(true);
      localStorage.setItem('popupUser', true);
      setTimeout(() => setIsVisible(true), 50);
      posthogPhoneNumberEvent(POSTHOG_CAPTURE_PHONE_SIGN_UP_FUNNEL_COMPLETED,
                          {
                            phoneNumber: user?.phoneNumber,
                            userId: user?._id
                          })
    }
  }, [user]);

  const validate = () => {
    setIsClosing(true);
    setIsVisible(false);
    setTimeout(() => {
      setOpen(false);
      setIsClosing(false);
    }, 400);
  };

  return open || isClosing ? (
    <div
      className="transition-all duration-500 ease-out h-[100dvh] fixed w-[100vw] z-40 left-0 top-0 overflow-x-visible">
      <div className={clsx(
        'fixed top-0 right-0 bottom-0 left-0 bg-black z-50',
        isVisible && !isClosing ? 'opacity-50' : 'opacity-0')} />
      <div
        className={clsx(
          'z-[50] bg-white px-8 overflow-y-auto overflow-x-hidden py-20 w-[100%] transition-transform duration-500 ease-out mx-auto flex flex-col items-center bottom-0 h-full fixed shadow-[0px_4px_0px_0px_rgba(0,0,0,0.1)]',
          isVisible && !isClosing ? 'translate-y-0' : 'translate-y-full',
        )}
      >
        <h1 className="">
          <p className="text-[#3D1F1E] opacity-70 geomanistMedium font-medium">
            {isNewUser ? 'Bienvenue sur' : 'Bon retour sur'}</p>
          <p
            class="mt-10 geomanistMedium font-bold text-[46px] leading-[46px] tracking-wide bg-gradient-to-r from-[#FFBB27] to-[#FF276F] bg-clip-text text-transparent">
            PikkoPay {isNewUser ? '' : ' !'}
          </p>
        </h1>

        <h2 className={clsx('mt-4 mx-2 text-3xl geomanistMedium font-medium text-center leading-[35px]',
                            { 'visible': isNewUser },
                            { 'invisible': !isNewUser },
        )}>
          Complète les informations liés à ton compte dès maintenant !
        </h2>
        <div className="w-full bottom-20 flex flex-col">
          <img
            src={pikkoWelcomeHome2}
            alt="pikkoLogo"
            className="pikkoLogo-phone-screen animatedLogo -mt-24"
          />
          <div className="relative bottom-20">
            {isNewUser ? <>
                <PrimaryButton label="Compléter mes infos"
                               className=""
                               onClick={() => navigate(UPDATE_USER)} />

                <PrimaryButton
                  label="Plus tard !"
                  onClick={validate}
                  className="!shadow-[0px_4px_0px_0px_rgba(0,0,0,0.1)] mt-8"
                  style={{
                    background: '#ffffff',
                    border: '2px solid #E6E6E6',
                  }}
                />

              </> :
              <PrimaryButton
                label="Commencer à scanner !"
                onClick={() => deployScan({
                                            store,
                                            user,
                                            entryQr,
                                            dispatch,
                                            axiosInstance,
                                            navigate,
                                            cartItems,
                                          })}
              />}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default UserInfo;
